export default __webpack_public_path__ + "static/media/img4.68bac762.jpg";